import React from "react";
import UploadAssignments from "../../components/StaffTabs/UploadAssignment/UploadAssignments";

const SendFeedback = () => {
  return (
    <div>
      
      <UploadAssignments/>
    </div>
  );
};

export default SendFeedback;
